<template>
  <van-form @submit="onSubmit">
    <van-cell-group inset style="text-align: left;">
      <label style="font-size: 14px; font-weight: 400; margin-bottom: 10px;">
        {{ $t('feedback.requiredField') }}
        <span style="color: red;">*</span>
      </label>
      <van-field
          v-model="feedbackContent"
          name="feedbackContent"
          required
          rows="4"
          autosize
          label=""
          type="textarea"
          maxlength="500"
          :placeholder="$t('feedback.placeholder-content')"
          show-word-limit
          style="background: #F5F5F5;border-radius: 10px;"
          :rules="[{ required: true, message:  $t('feedback.rules.required') }]"
      />
    </van-cell-group>
    <van-cell-group inset style="text-align: left;margin-top: 10px;">
      <label style="font-size: 14px; font-weight: 400; margin-bottom: 10px;">
        {{ $t('feedback.contact') }}
      </label>
      <van-field
          v-model="contactInfo"
          name="contactInfo"
          rows="1"
          autosize
          label=""
          type="text"
          maxlength="100"
          show-word-limit
          :placeholder="$t('feedback.placeholder-contact')"
          style="background: #F5F5F5;border-radius: 10px;"
          :rules="[{ required: false, pattern, message: $t('feedback.rules.required-contact') }]"

      />
    </van-cell-group>
    <van-cell-group inset style="text-align: left;margin-top: 10px;">
      <label style="font-size: 14px; font-weight: 400; margin-bottom: 10px;">
        {{ $t('feedback.addPic') }}
      </label>
      <van-field name="feedbackAttachment" style="padding: 0;">
        <template #input>
          <van-uploader
              :before-read="beforeRead"
              v-model="fileList"
              accept="image/*"
              :max-count="3"
              :max-size="3 * 1024 * 1024"
              @oversize="onOversize"/>
        </template>
      </van-field>
    </van-cell-group>
    <div style="margin: 16px;">
      <van-button round block type="primary" native-type="submit" style="background: #6E62F0;">
        {{ $t('feedback.submitButton') }}
      </van-button>
    </div>
  </van-form>
</template>
<script>
import {ref, watch} from 'vue';
import {useI18n} from "vue-i18n";
import {closeToast, showLoadingToast, showToast} from "vant";
import axios from 'axios';
import {useRoute} from "vue-router";

export default {
  setup() {
    const loading = ref(false); // 添加 loading 状态
    const route = useRoute();
    const feedbackContent = ref(null);
    const contactInfo = ref(null);
    const {locale} = useI18n();
    // 正则表达式：匹配手机号或邮箱
    const pattern = /^$|^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$|^(1\d{10}|(\+\d{1,3})?\d{8,15})$/;

    const fileList = ref([]);

    const onOversize = () => {
      showToast('文件大小不能超过 3M');
    };

    const beforeRead = (file) => {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        showToast('请上传 jpg、png 格式图片');
        return false;
      }
      return true;
    };
    const onSubmit = async (values) => {
      // 显示加载提示
      showLoadingToast({
        message: '提交中...', forbidClick: true, position: 'top'
      });
      let token = null;
      try{
        token = window.NativeBridge.getToken();
      }catch (error){
        showToast(`Token获取失败: ${error}`, {duration: 3000});
        return;
      }

      if (!token) {
        showToast('身份验证失败，请重新登录');
        return;
      }
      try {
        loading.value = true;

        // 创建 FormData 对象
        const formData = new FormData();

        // 添加普通字段
        formData.append('feedbackContent', values.feedbackContent);
        if (values.contactInfo) {
          formData.append('contactInfo', values.contactInfo);
        }


        // 添加附件文件
        if (values.feedbackAttachment && values.feedbackAttachment.length > 0) {
          values.feedbackAttachment.forEach(file => {
            formData.append('feedbackAttachment', file.file);
          });
        }

        // HACK 发布正式调整提交URL
        const env = ref(route.query.env || '');
        let url = 'https://pms.zhuhaijiuyin.com/support/feedback/add';
        if (env.value === 'dev') {
          url = 'http://localhost:1024/support/feedback/add';
        } else if (env.value === 'pre') {
          url = 'https://pms.aboveseal.cn/support/feedback/add';
        }
        console.log('提交URL:', url);
        const response = await axios.post(
            url,
            formData, {
              headers: {
                'x-access-token': `${token}`,
              }
            });
        // 在这里关闭加载提示
        closeToast();
        loading.value = false;
        if (response.data.code === 0) {
          showToast('反馈成功');
          feedbackContent.value = null;
          contactInfo.value = null;
          // 重置文件列表
          fileList.value = [];
        } else {
          showToast(response.data.msg);
        }
      } catch (error) {
        console.error('提交失败:', error);
        showToast('提交失败，请重试');
      }
    };
    // 监听路由变化，更新语言
    watch(
        () => route.query.lang,
        (newLang) => {
          if (newLang && ['en', 'zh', 'zh-Hant', 'ko'].includes(newLang)) {
            locale.value = newLang
          } else if (newLang && newLang.startsWith('zh')) {
            locale.value = 'zh';
          } else if (newLang === '' || newLang === null || newLang === undefined) {
            const browserLang = (navigator.language || 'en-US').split('-')[0];
            newLang = ['en', 'zh'].includes(browserLang) ? browserLang : 'en'

            locale.value = newLang;
          } else {
            locale.value = 'en';
          }
        },
        {immediate: true}
    );
    return {
      feedbackContent,
      contactInfo,
      locale,
      fileList,
      onSubmit,
      onOversize,
      beforeRead,
      pattern,
    }
  }
}
</script>
<style scoped>
:deep(.van-field__word-limit) {
  color: #999999;
}

:deep(.van-uploader__upload) {
  border-radius: 10px;
}

:deep(.van-uploader__preview-image) {
  border-radius: 10px;
}

:deep(.van-uploader__preview-delete--shadow) {
  border-radius: 10px 10px 10px 10px;
}

:deep(.van-uploader__preview-delete) {
  top: 1px !important;
}
</style>